import fullpage from 'fullpage.js';

(function($) {
  var animation = null;

  $(function() {
    $('#fullpage').fullpage({
      autoScrolling: true,
      licenseKey: 'K43O6-6MN3I-KD5V6-OKTJK-VWNMM',
      responsiveWidth: window.ScreenLG,
      animateAnchor: $(window).width() > ScreenSM ? true : false,
      afterLoad: function(origin, destination, direction, trigger) {
        var $destinationItem = $(destination.item);
        updateBodyScrollClass(destination);
        $('.page-header').delay().fadeIn(1000);

        if(animation) {
          animation.destroy();
        }

        var dataAnimation = $destinationItem.data('animation');
        if(dataAnimation && $(window).width() > ScreenSM) {
          var $lottie = $(destination.item).find('.lottie');
          $lottie.show();

          var params = {
            container: $lottie.get(0),
            renderer: 'svg',
            autoplay: true,
            loop: false,
            path: spurwerk_vars.animations_dir + dataAnimation + '.json',
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid slice'
            }
          };

          $('.page-header').fadeOut(function() {
            animation = lottie.loadAnimation(params);

            animation.onComplete = function() {
              $lottie.fadeOut(1000);
              $('.page-header').delay().fadeIn(1000);
              $('.fixed-button').removeClass('fixed-button--hidden');
            }

            $destinationItem
              .removeAttr('data-animation')
              .removeData('animation');
          });
        } else {
          $('.fixed-button').removeClass('fixed-button--hidden');
        }
      },
      onLeave: function(origin, destination, direction, trigger) {
        var $origin = $(origin.item);
        var $destination = $(destination.item);
        var destinationAnimation = $destination.data('animation');

        if(destinationAnimation) {
          $destination.find('.lottie').show();
          $('.fixed-button').addClass('fixed-button--hidden');
        } else {
          $destination.find('.lottie').hide();
        }

        var $formReset = $origin.find('.form__reset');
        var $sentForm = $origin.find('.wpcf7-form.sent');

        if($formReset.length > 0 && $sentForm.length > 0) {
          $formReset.trigger('click');
        }

        $('.cta').addClass('cta--hidden');

        updateBodyScrollClass(destination);
      }
    });

    // Firefox hack - call `reBuild` to support overflow section scrolling,
    // otherweise everything is cut off and weird
    $(document).ready(function () {
      fullpage_api.reBuild();
    });

    $('.home .page-header__logo-link').click(function(e) {
      e.preventDefault();
      $.fn.fullpage.moveTo(1);
    });

    $('[data-scrollto-section]').click(function(e) {
      e.preventDefault();
      var targetAnchor = $(this).attr('href').replace('#', '');
      var $element = $('[data-anchor="' + targetAnchor + '"]');
      if($element.length > 0) {
        $.fn.fullpage.moveTo($element.index() + 1);
      } else {
        window.location = $(this).attr('href');
      }
    });

    $('.fixed-button').click(function(e) {
      e.preventDefault();
      var href = $(this).attr('href');
      var targetAnchor = $(this).data('target-anchor');
      var $element = $('[data-anchor="' + targetAnchor + '"]');
      if($element.length > 0) {
        $.fn.fullpage.moveTo($element.index() + 1);
      }

      window.location = href;
    });

    // Mobile scroll to sections on click
    $('.main-nav a[href*="#"]').click(function(e) {
      if($('body').hasClass('fp-responsive')) {
        var href = $(this).attr('href');
        var anchor = href.match(/\#(.*)$/g);
        if(anchor) {
          anchor = anchor[0].replace('#', '');
          var $el = $('[data-anchor="' + anchor + '"]');
          if($el.length > 0) {
            scrollToEl($el);
            history.pushState({}, '', '#' + anchor);
          }
        }
      }
    });

    // Mobile scroll to sections on page load
    if ($(window).width() <= ScreenSM) {
      var hash = window.location.hash;
      if(hash) {
        var anchor = hash.replace('#', '');
        var $el = $('[data-anchor="' + anchor + '"]');
        if($el.length > 0) {
          scrollToEl($el);
        }
      }
    }
  });

  function updateBodyScrollClass(destination) {
    if(destination.index != 0) {
      $('body').addClass('scrolled');
    } else {
      $('body').removeClass('scrolled');
    }

    if($(destination.item).hasClass('section--white') || $(destination.item).hasClass('hero')) {
      $('body').removeClass('black').addClass('white');
    } else {
      $('body').removeClass('white').addClass('black');
    }

    if($(destination.item).hasClass('site-plan')) {
      $('.page-header').addClass('page-header--transparent');
    } else {
      $('.page-header').removeClass('page-header--transparent');
    }
  }
})(jQuery);
